export default __webpack_public_path__ + "static/assets/fonts/97c6faf73d0259cc5aff116df880fef3.woff";